<template>
  <v-card
    :loading="loading"
    class="my-4"
  >
    <v-card-title class="mt-3">
      Outputs
      <v-spacer />
      <v-btn
        color="primary"
        @click="add"
      >
        Add
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :items="outputs"
        :headers="headers"
        class="row-pointer"
        :items-per-page="1000"
        mobile-breakpoint="0"
        @click:row="rowClick"
      >
        <template #[`item.includeBleed`]="{ item }">
          <v-icon
            v-if="item.includeBleed"
            color="success"
          >
            mdi-check
          </v-icon>
        </template>
        <template #[`item.includeGuides`]="{ item }">
          <v-icon
            v-if="item.includeGuides"
            color="success"
          >
            mdi-check
          </v-icon>
        </template>
        <template #[`item.actions`]="{}">
          <v-icon>more_vert</v-icon>
        </template>
      </v-data-table>
    </v-card-text>
    <OutputsEdit @save="loadData" />
  </v-card>
</template>

<script>
import OutputsEdit from '@/components/outputs/Edit';
import { mapGetters } from 'vuex';

export default {
  name: 'ListOutputs',
  components: { OutputsEdit },
  data() {
    return {
      loading: false
    };
  },

  computed: {
    headers() {
      return [
        { text: 'Id', value: 'id' },
        { text: 'Name', value: 'name' },
        { text: 'Imposition Name', value: 'imposition.name' },
        { text: 'Imposition Description', value: 'imposition.description' },
        { text: 'Optimization Profile?', value: 'optimizationProfile.name' },
        { text: 'Include Bleed', value: 'includeBleed' },
        { text: 'Include Guides', value: 'includeGuides' },
        { text: '', value: 'actions', sortable: false }
      ];
    },
    ...mapGetters({ outputs: 'outputs/list' })
  },

  async mounted() {
    this.loadData();
  },

  methods: {
    loadData() {
      this.loading = true;
      this.$store
        .dispatch('outputs/getList')
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    add() {
      this.$bus.$emit(this.$enums.EVENT_BUS_EVENTS.EDIT_OUTPUT_SHOW, {});
    },
    rowClick(item) {
      this.$bus.$emit(this.$enums.EVENT_BUS_EVENTS.EDIT_OUTPUT_SHOW, {
        id: item.id
      });
    }
  }
};
</script>
